module.exports = __webpack_public_path__ + "assets/img/16_1721_big.90b1c157.jpg";